import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import FilterView from "../../common/filter";
import { Form } from "react-bootstrap";
import type GatewaysViewModel from "viewModels/enforcement/gateways/gatewaysViewModel";
import { translateGeneral } from "utils/localizations";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import AdvancedInput from "@edaz/edazkit/controls/AdvancedInput";

export interface GateWaysFiltersProps {
  vm: GatewaysViewModel;
}

const GateWaysFilters = observer((props: GateWaysFiltersProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <Form.Row>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateFilterAttribute("externalGatewayIdent")}</Form.Label>
          <AdvancedInput target={vm.filter} property="externalGatewayIdent" placeholder={translateGeneral("search")} />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateFilterAttribute("includeDeleted")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="includeDeleted"
            items={vm.booleanOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
      </Form.Row>
    </FilterView>
  );
});

export default GateWaysFilters;
